import { createSlice } from "@reduxjs/toolkit";

// initial state
const initialState = {
  filter: "showAll",
  search: "",
};

// create slice
const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    filterReducer: (state, action) => {
      state.filter = action.payload;
    },
    searchReducer: (state, action) => {
      state.search = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { filterReducer, searchReducer } = filterSlice.actions;
